<template>
  <div class="card card-custom gutter-b example example-compact p-8">
    <soha-page-loading v-if="loading" />
    <soha-no-access
      v-else-if="!access"
      :message="$t(`${I18nPrefix}ACCESS_MESSAGE`)"
    />
    <div v-else class="row m-0">
      <div class="col-lg-12">
        <label class="soha-edit-company-title">
          {{ $t(`${I18nPrefix}EDIT_COMPANY`) }}
        </label>
      </div>
      <div class="col-lg-4 col-sm-6 py-4">
        <soha-text-field
          name="companyName"
          :placeholder="$t(`${I18nPrefix}COMPANY_NAME`)"
          class="w-100"
          v-model="companyName"
          disabled
        />
      </div>
      <div class="col-lg-4 col-sm-6 py-4">
        <soha-text-field
          name="website"
          :placeholder="$t(`${I18nPrefix}WEB_SITE`)"
          class="w-100"
          v-model="website"
        />
      </div>
      <div class="col-lg-4 col-sm-6 py-4">
        <soha-select
          name="jobField"
          class="w-100"
          :options="jobFields"
          :placeholder="$t(`${I18nPrefix}JOB_FIELD`)"
          v-model="jobField"
          :key="jobFieldSelectKey"
        />
      </div>
      <div class="col-lg-4 col-sm-6 py-4">
        <soha-select
          name="city"
          class="w-100"
          :placeholder="$t(`${I18nPrefix}CITY`)"
          v-model="cityId"
          :options="provinceCities"
          :key="citySelectKey"
        />
      </div>
      <div class="col-lg-4 col-sm-6 py-4">
        <soha-text-field
          type="number"
          name="numberEmployee"
          :placeholder="$t(`${I18nPrefix}NUMBER_EMPLOYEE`)"
          class="w-100"
          v-model="numberEmployee"
        />
      </div>

      <div class="col-lg-4 col-sm-6 py-4">
        <soha-text-field
          type="number"
          name="phone"
          :maxLength="11"
          :placeholder="$t(`${I18nPrefix}PHONE`)"
          class="w-100"
          v-model="phone"
        />
      </div>
      <div class="col-lg-4 col-sm-6 py-4">
        <soha-text-field
          name="dateEstablishment"
          :placeholder="$t(`${I18nPrefix}DATE_ESTABLISHMENT`)"
          class="w-100 date-picker-input"
          v-model="dateEstablishment"
          icon="date"
          icon-position="left"
          icon-cursor
          icon-color="secondary"
          readonly
        />
        <soha-date-picker
          v-model="dateEstablishment"
          custom-input=".date-picker-input"
          simple
        />
      </div>
      <div class="col-lg-8 col-sm-6 py-4">
        <soha-text-area
          name="address"
          class="w-100"
          small
          v-model="address"
          :placeholder="$t(`${I18nPrefix}ADDRESS`)"
        />
      </div>
      <div class="col-lg-12 py-4 text-center">
        <label class="m-auto cursor-pointer" for="file">
          <div class="soha-company-logo-box">
            <img :src="croppedImage" v-if="croppedImage" />
            <span v-else>
              <inline-svg src="/media/svg/soha/icons/plus.svg" />
              <span class="font-size-sm d-block mt-2">
                {{ $t(`${I18nPrefix}UPLOAD_LOGO`) }}
              </span>
            </span>
          </div>
          <span
            v-if="croppedImage"
            class="font-size-sm d-block mt-3 secondary-color svg svg-icon svg-icon-secondary"
          >
            {{ $t(`${I18nPrefix}UPLOAD_NEW_LOGO`) }}
          </span>
        </label>
        <input
          id="file"
          ref="file"
          type="file"
          @change="onFileChange"
          accept="image/*"
          v-show="false"
        />

        <soha-modal
          id="crop-image"
          @hide="clearDataModal"
          :title="$t(`${I18nPrefix}CRROPPED_IMAGE`)"
          hide-footer
        >
          <div slot="body">
            <vue-cropper
              v-if="image"
              ref="cropper"
              :src="image"
              style="width: 100%; height: 30.769rem"
              :aspect-ratio="1"
              :fixed-crop-area="true"
            />
            <soha-button
              class="w-100 mt-5"
              name="croppedImage"
              @click="getCroppedImage"
              :text="$t(`${I18nPrefix}CRROPPED_IMAGE`)"
            />
          </div>
        </soha-modal>
      </div>
      <div class="col-lg-12 py-4">
        <soha-button
          class="float-right"
          name="editCompanyInfo"
          @click="editCompanyInfo"
          :text="$t(`${I18nPrefix}EDIT_COMPANY`)"
          :loading="btnLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import ValidationMixin from "@/mixins/ValidationMixin";
import UIMixin from "@/mixins/UIMixin";
import GeneralMixin from "@/mixins/GeneralMixin";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "EditCompanyInfo",

  mixins: [ValidationMixin, UIMixin, GeneralMixin],

  components: {
    "vue-cropper": VueCropper,
  },

  data() {
    return {
      I18nPrefix: "PAGES.SETTING.EDIT_COMPANY.",
      access: true,
      loading: false,
      btnLoading: false,
      companyName: null,
      website: null,
      cityId: null,
      jobField: null,
      phone: null,
      address: null,
      dateEstablishment: null,
      numberEmployee: null,
      provinceCities: [],
      jobFields: [],
      citySelectKey: 0,
      jobFieldSelectKey: 0,
      image: null,
      croppedImage: null,
      croppedFile: null,
    };
  },

  mounted() {
    this.getProvinceCities((data) => (this.provinceCities = data));
    this.getJobFields((data) => (this.jobFields = data));
    this.getCompanyData();
    this.citySelectKey++;
    this.jobFieldSelectKey++;
  },

  methods: {
    getCompanyData() {
      this.loading = true;
      ApiService.get(`/api/v2/companies/${this.companyId}`).then(({ data }) => {
        if (!data.code) {
          this.companyName = data.name;
          this.website = data.site;
          this.jobField = data.job_field ? data.job_field.id.toString() : null;
          this.numberEmployee = data.numberEmployees;
          this.cityId = data.cityId;
          this.phone = data.phone;
          this.dateEstablishment = data.dateEstablishment;
          this.address = data.address;
          data.logo_file?.path && (this.croppedImage = this.$frontUrl + 'files/' + data.logo_file?.path);
          data.logo_file?.path && (this.croppedFile = this.$frontUrl + 'files/' + data.logo_file?.path);
        } else if (+data.code === 403) {
          this.access = false;
        } else {
          this.errorToast(data.message);
        }
        this.loading = false;
      });
    },

    editCompanyInfo() {
      this.btnLoading = true;
      ApiService.post(
        `/api/v2/companies/${this.companyId}`,
        this.createFormData()
      ).then(({ data }) => {
        if (data.code == 204) {
          this.successToast(data.message);
        } else {
          this.errorToast(data.message);
        }
        this.btnLoading = false;
      });
    },

    createFormData() {
      let formData = new FormData();
      const fields = {
        cityId: this.cityId,
        jobFieldId: this.jobField,
        name: this.companyName,
        site: this.website,
        address: this.address,
        numberEmployees: this.numberEmployee,
        phone: this.phone,
        dateEstablishment: this.dateEstablishment,
        logo: this.croppedFile,
      };

      Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
      });
      return formData;
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (this.validateFile(file)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.$bvModal.show("crop-image");
      }
    },

    getCroppedImage() {
      const cropper = this.$refs.cropper.getCroppedCanvas({
        width: 90,
        height: 90,
      });
      if (cropper) {
        cropper.toBlob((blob) => {
          const file = new File([blob], "company-logo.jpg", {
            type: "image/jpg",
          });
          this.croppedFile = file;
          this.croppedImage = URL.createObjectURL(blob);
        }, "image/jpg");
      }
      this.$bvModal.hide("crop-image");
    },

    validateFile(file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
      ];

      if (file) {
        if (validImageTypes.includes(file.type)) {
          return true;
        } else {
          this.errorToast("فایل انتخاب شده از نوع تصویر نیست.");
          return false;
        }
      }
      return false;
    },

    clearDataModal() {
      this.image = null;
      this.$refs.file.value = null;
    },
  },

  computed: {
    ...mapGetters(["companyId"]),
  },
};
</script>

<style scoped>
.soha-edit-company-title {
  font-weight: bolder;
  color: var(--primary-color);
  margin: 1.538rem 0;
  width: 100%;
  padding-bottom: 0.384rem;
}
.soha-company-logo-box {
  margin: auto;
  border: 0.153rem solid var(--primary-color);
  width: 6.923rem;
  height: 6.923rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.soha-company-logo-box img {
  width: 100%;
  height: 100%;
}

.soha-company-logo-box svg {
  width: 3rem;
  height: 3rem;
}
</style>
